module.exports = __webpack_public_path__ + "img/tema-1-10.aa246bf0.svg";